import { Component, OnInit, } from '@angular/core';


declare const google: any;
@Component({
  selector: 'app-user-registration',
  templateUrl: './user-registration.component.html',
  styleUrls: ['./user-registration.component.css']
})
export class UserRegistrationComponent implements OnInit {
  constructor() {

  }
  ngOnInit() {

  }

}